/* ============================================================================
   CNC LIBRARY FRONT — progressive enhancement only.
   The page is fully server-rendered and works with NO JS. This file adds
   nothing critical; it is deferred and fails silent.

   CAST: the open-book is a CYCLING set of character leaves driven by hidden
   radios. Character switching is PURE CSS (the dot-labels check a radio, the
   checked radio reveals its leaf) and works with NO JS. This script is only an
   ENHANCEMENT: it un-hides the prev/next arrows and wires them to check the
   previous / next radio, wrapping around. No-JS users navigate via the dots.
   ============================================================================ */
(function () {
  'use strict';
  var cast = document.querySelector('[data-libf-cast]');
  if (!cast) return;

  var radios = Array.prototype.slice.call(cast.querySelectorAll('.libf-cast__radio'));
  if (radios.length < 2) return;   // nothing to cycle

  var prev = cast.querySelector('[data-libf-prev]');
  var next = cast.querySelector('[data-libf-next]');
  if (!prev || !next) return;

  function currentIndex() {
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return i; }
    return 0;
  }
  function go(delta) {
    var n = radios.length;
    var i = (currentIndex() + delta + n) % n;   // wrap-around
    radios[i].checked = true;
    // radios are aria-hidden/off-flow; fire change so any listeners stay in sync
    radios[i].dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Arrows were server-rendered hidden (so no-JS shows only the dots). Reveal
  // them now that JS is running, and wire the cycle.
  prev.hidden = false;
  next.hidden = false;
  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });
})();

/* Swipe shelf — desktop arrows scroll the shelf; native touch swipe on mobile. */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-libf-swipe]');
  if (!wrap) return;
  var track = wrap.querySelector('[data-libf-swipetrack]');
  if (!track) return;
  function step() {
    var b = track.querySelector('.libf-face');
    var w = b ? b.getBoundingClientRect().width : 200;
    return (w + 20) * 2;
  }
  var prev = wrap.querySelector('[data-libf-swipe-prev]');
  var next = wrap.querySelector('[data-libf-swipe-next]');
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
})();
